import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const RedirectToUserCreate = () => {
    const history = useHistory();

    useEffect(() => {
        history.replace('/users/create');
    }, [history]);

    return null;
};

export default RedirectToUserCreate;
